import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import reviewsData from "../../Data/reviews/reviewsData.json";

export default function Reviews() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Отзывы пациентов
      </h1>

      <p className="reviews__description">
        Уважаемые посетители! Нам важно Ваше мнение о качестве оказания
        медицинской помощи, уровне сервиса и работе специалистов ГБУ СО
        «УрНИИДВиИ». Ознакомьтесь с отзывами наших пациентов или оставьте
        собственное мнение о посещении института.
      </p>

      {/* <div className="reviews__info">
        <div className="reviews__info-card">
          <span className="reviews__info-number">250+</span>
          <span className="reviews__info-text">Получено отзывов</span>
        </div>

        <div className="reviews__info-card">
          <span className="reviews__info-number">96%</span>
          <span className="reviews__info-text">Положительных оценок</span>
        </div>

        <div className="reviews__info-card">
          <span className="reviews__info-number">24/7</span>
          <span className="reviews__info-text">Прием обращений</span>
        </div>
      </div> */}

      <h4 className="dissertation__button">
        <a
          href="/patients/reviews/new-reviews"
          className="prevention__link employees__link dissertation__link"
        >
          Оставить отзыв
        </a>
      </h4>

      <div className="reviews__list">
        {[...reviewsData].reverse().map((item) => (
          <div key={item.id} className="reviews__card">
            <div className="reviews__card-top">
              <h3 className="reviews__card-name">{item.name}</h3>
              <span className="reviews__card-date">{item.date}</span>
            </div>

            <p className="reviews__card-text">{item.text}</p>
          </div>
        ))}
      </div>
      <p className="reviews__description"></p>
    </section>
  );
}
